import HowStart from './how-start';

export default HowStart;
